import { Component, OnInit } from "@angular/core"; import { Location } from "@angular/common";
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ListeAchatService } from '../../services/liste-achat-service';
import { ListeAchatEntite } from '../../entites/liste-achat';
import { ItemListeAchatEntite } from '../../entites/item-liste-achat';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';


@Component({
    templateUrl: './saisir-liste-achat-e4.component.html',
    styleUrls: ['./saisir-liste-achat-e4.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class SaisirListeAchatEtape4Component extends BaseComponent implements OnInit {

    estSucces: boolean = false;
    estErreur: boolean = false;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
		appMain: AppMainComponent, location: Location, 
        private breadcrumbService: BreadcrumbService,
        private listeAchatService: ListeAchatService,
        private messageService: MessageService,
        public dialogService: DialogService,
        public routerService: Router) {
        super(sdb, profilService, route, routerService, appMain);
        this.breadcrumbService.setItems([
            { label: 'Saisir une liste d\'achat', routerLink: '/listeachat/etape1' },
            { label: 'Étape 2', routerLink: '/listeachat/etape2' },
            { label: 'Étape 3', routerLink: '/listeachat/etape3' },
            { label: 'Étape 4' },
        ]);
    }

    ngOnInit() {

        this.verifierAccesPage('liste_achat');

        if (!this.listeAchatService.modeleListeAchatId) {
            this.routerService.navigateByUrl('listeachat/etape1');
            return;
        }

        this.listeAchatService.CreerListe(this.listeAchatService.listeAchat).then(res => {
            if (res.estUnSucces) {

                this.estSucces = true;
            } else {
                this.estErreur = true;
            }
            this.CompleterChargement();
        }).catch(() => {
            this.estErreur = true;
            this.CompleterChargement();
        });
    }

    reessayerEnvoi() {

        this.DemarrerChargement();

        this.estSucces = false;
        this.estErreur = false;


        this.listeAchatService.CreerListe(this.listeAchatService.listeAchat).then(res => {
            if (res.estUnSucces) {

                this.estSucces = true;
            } else {
                this.estErreur = true;
            }
            this.CompleterChargement();
        }).catch(() => {
            this.estErreur = true;
            this.CompleterChargement();
        });
    }


}
